import axios from "../axios";
import { AxiosResponse } from "axios";
import { decode } from "@msgpack/msgpack";
import {
    IFetchWaveParams,
    IFetchWaveData,
    IFetchTrendData,
    IWaveListData,
    IWaveListParams,
    IWaveDetailParams,
    IWaveDetailData,
    IWaveHaveDefaultData,
    IWaveCepstrumParams,
    IWaveCepstrumData,
    IWaveAxisOrbitParams,
    IWaveAxisOrbitData,
    IWaveGetUnbindSensorWaveListParams,
    IWaveGetUnbindSensorWaveListData,
    IWaveDetail2Params,
    IWaveDetail2Data,
    IWaveAccelerationFreqParams,
    IWaveAccelerationFreqData,
    IWaveMsgPackDetailParams,
    IMsgPackWaveDetailData
} from "./wave.types";
import { IDataWrapper } from "../types";

/**
 * 特征值
 */
export function fetchTrendData(params: IFetchWaveParams) {
    return axios<IFetchTrendData>({
        url: "/statistics/getDataListByHour",
        method: "get",
        params,
    });
}

/**
 * 波形
 */
export function fetchWaveData(params: IFetchWaveParams) {
    return axios<IFetchWaveData>({
        url: "/statistics/health/wave",
        method: "get",
        params,
    });
}

/**
 * 分页获取波形记录
 */
export function waveList(params: IWaveListParams) {
    return axios<IWaveListData>({
        method: 'post',
        url: '/wave/list/findPage',
        data: params,
    })
}

/**
 * 获取波形记录
 */
export function waveDetail(params: IWaveDetailParams) {
    return axios<IWaveDetailData>({
        method: 'post',
        url: '/wave/detail',
        params,
    })
}

/**
 * MessagePack获取波形详情
 */
export function getWaveFFTMsgPack<T = IDataWrapper<IMsgPackWaveDetailData>>(params: IWaveMsgPackDetailParams) {
    return axios<ArrayBuffer, AxiosResponse<ArrayBuffer>, IWaveMsgPackDetailParams>({
        method: 'post',
        url: '/wave/detail/msgpack',
        data: params,
        responseType: 'arraybuffer',
        rawResponse: true,
        headers: {
            Accept: 'application/x-msgpack',
            'Content-Type': 'application/json;charset=UTF-8'
        },
    }).then(res => decode(new Uint8Array(res.data)) as T)
}

/**
 * 获取声纹原始波形 
 */
export function waveDetail2(params: IWaveDetail2Params) {
    return axios<IWaveDetail2Data>({
        method: 'get',
        url: '/wave/getWaveDetail',
        params,
    })
}


/**
 * 到谱图
 */
export function waveCepstrum(params: IWaveCepstrumParams) {
    return axios<IWaveCepstrumData>({
        method: 'get',
        url: '/wave/getCepstrum',
        params,
    })
}

/**
 * 轴位移
 */
export function waveAxisOrbit(params: IWaveAxisOrbitParams) {
    return axios<IWaveAxisOrbitData>({
        method: 'get',
        url: '/wave/getAxisOrbit',
        params,
    })
}

/**
 * 未绑定传感器波形列表
 */
export function waveGetUnbindSensorWaveList(params: IWaveGetUnbindSensorWaveListParams) {
    return axios<IWaveGetUnbindSensorWaveListData>({
        method: 'get',
        url: '/wave/getUnbindSensorWaveList',
        params,
    })
}

/**
 * 获取图谱分析默认返回
 */
export function waveHaveDefault() {
    return axios<IWaveHaveDefaultData>({
        method: 'get',
        url: '/waveform/chart/waveHave'
    })
}

/**
 * 获取加速度频率
 */
export function waveAccelerationFreq(params: IWaveAccelerationFreqParams) {
    return axios<IWaveAccelerationFreqData>({
        method: 'get',
        url: '/wave/getWaveAccelerationFreq',
        params,
    })
}
